import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { format, formatDistanceToNow, isAfter, isBefore } from 'date-fns'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(date: string | Date | null | undefined, fmt = 'dd MMM yyyy') {
  if (!date) return '—'
  return format(new Date(date), fmt)
}

export function formatDateTime(date: string | Date | null | undefined) {
  if (!date) return '—'
  return format(new Date(date), 'dd MMM yyyy HH:mm')
}

export function timeAgo(date: string | Date | null | undefined) {
  if (!date) return '—'
  return formatDistanceToNow(new Date(date), { addSuffix: true })
}

export function isOverdue(date: string | Date | null | undefined) {
  if (!date) return false
  return isBefore(new Date(date), new Date())
}

export function formatCurrency(amount: number | null | undefined, currency = 'GBP') {
  if (amount == null) return '—'
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency, maximumFractionDigits: 0 }).format(amount)
}

export const PRIORITY_LABELS: Record<string, string> = {
  EMERGENCY: 'Emergency',
  URGENT: 'Urgent',
  HIGH: 'High',
  STANDARD: 'Standard',
  LOW: 'Low',
  PLANNED: 'Planned',
}

export const STATUS_LABELS: Record<string, string> = {
  NEW: 'New',
  ASSIGNED: 'Assigned',
  IN_PROGRESS: 'In Progress',
  ON_HOLD: 'On Hold',
  PENDING_PARTS: 'Pending Parts',
  PENDING_CONTRACTOR: 'Pending Contractor',
  COMPLETED: 'Completed',
  VERIFIED: 'Verified',
  CANCELLED: 'Cancelled',
}

export const PRIORITY_COLORS: Record<string, string> = {
  EMERGENCY: 'badge-emergency',
  URGENT: 'badge-urgent',
  HIGH: 'badge-high',
  STANDARD: 'badge-standard',
  LOW: 'badge-low',
  PLANNED: 'badge-planned',
}

export const STATUS_COLORS: Record<string, string> = {
  NEW: 'status-new',
  ASSIGNED: 'status-assigned',
  IN_PROGRESS: 'status-progress',
  ON_HOLD: 'status-hold',
  COMPLETED: 'status-completed',
  VERIFIED: 'status-verified',
  CANCELLED: 'status-cancelled',
}
